import React from 'react';

import Page from '../../../page.jsx';
import partnerPropTypes from '../../../partnerPropTypes.js';

const SellerVerificationRequired = ({ partner }) => (
    <Page heading={`${partner.name} må bekrefte sin identitet`}>
        <div>
            <p className="r-ptl">
                Trygg betaling blir tilgjengelig når selger har{' '}
                <a href="https://hjelpesenter.finn.no/hc/no/articles/208426349">
                    bekreftet sin identitet
                </a>{' '}
                (blitt verifisert bruker).
            </p>
        </div>
    </Page>
);

SellerVerificationRequired.propTypes = {
    partner: partnerPropTypes.isRequired,
};

export default SellerVerificationRequired;



// WEBPACK FOOTER //
// ./safeTrade/buyer/payment/statusDetails/sellerVerificationRequired.jsx